import request from "../shared/http";

class PostService {
  static async list() {
    const { data } = await request.get("/posts");
    return data;
  }

  static async create(body) {
    const { data } = await request.post("/posts", body);
    return data;
  }

  static async update(id, body) {
    const { data } = await request.patch(`/posts/${id}`, body);
    return data;
  }

  static async remove(id) {
    const { data } = await request.delete(`/posts/${id}`);
    return data;
  }

  static async schedule(id, body) {
    const { data } = await request.post(`/posts/${id}/schedule`, body);
    return data;
  }

  static async publish(id) {
    const { data } = await request.post(`/posts/${id}/publish`);
    return data;
  }

  static async cancel(id) {
    const { data } = await request.post(`/posts/${id}/cancel`);
    return data;
  }

  static async retry(id) {
    const { data } = await request.post(`/posts/${id}/retry`);
    return data;
  }

  static async upload(file) {
    const { data } = await request.post("/posts/media", file, {
      headers: {
        "Content-Type": file.type,
        "X-Filename": file.name,
      },
      maxBodyLength: 100 * 1024 * 1024,
      maxContentLength: 100 * 1024 * 1024,
    });
    return data;
  }

  static async listSlots() {
    const { data } = await request.get("/posts/slots");
    return data;
  }

  static async createSlot(body) {
    const { data } = await request.post("/posts/slots", body);
    return data;
  }

  static async updateSlot(id, body) {
    const { data } = await request.patch(`/posts/slots/${id}`, body);
    return data;
  }

  static async deleteSlot(id) {
    const { data } = await request.delete(`/posts/slots/${id}`);
    return data;
  }
}

export default PostService;
